var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{staticClass:"d-flex",attrs:{"cols":"12","md":"6"}},[_c('data-card',{attrs:{"title":_vm.$t ('view.section.basic')}},[_c('name-value-block',{attrs:{"items":_vm.basicData}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }